import React from "react";

import { TargetingIcon } from "orion-components/SharedComponents";

import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { Translate, getTranslation } from "orion-components/i18n";

import CheckIcon from "@mui/icons-material/Check";

import moment from "moment";

const RenderPersonnel = ({
	person,
	key,
	style,
	timeFormatPreference,
	setPendingCheckedValue,
	setPendingPersonId,
	setShowConfirmDialog
}) => {
	const timeFormatString = timeFormatPreference === "12-hour" ? "MM-DD-YYYY hh:mm:ss A" : "MM-DD-YYYY HH:mm:ss";

	return (
		<div key={key} style={{ ...style }} className="evacuation-personnel-list-container" data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-div">
			<div className="evacuation-personnel-list" data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-div-2">
				<div className="list-section-1" data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-div-3">
					<div className="list-section-1-wrapper" data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-div-4">
						<div className="person-label">
							{/* non-breaking space to keep spacing consistent */}
							<span>{person.firstName}&nbsp;</span>
							{person?.middleName && <span>{person.middleName}&nbsp;</span>}
							<span>{person.lastName}</span>
						</div>
						<FormControlLabel
							control={
								<Checkbox
									checked={person.isAccounted}
									onChange={(e) => {
										setPendingCheckedValue(e.target.checked);
										setPendingPersonId(person.id); // Track which person is being updated
										setShowConfirmDialog(true);
									}}
									icon={
										<Box
											sx={{
												width: 14,
												height: 14,
												border: "2px solid #666c74",
												borderRadius: "2px"
											}}
										/>
									}
									checkedIcon={
										<Box
											sx={{
												width: 14,
												height: 14,
												border: "2px solid #00BFFF",
												borderRadius: "2px",
												backgroundColor: "#00BFFF",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												fontSize: 14,
												color: "#fff",
												fontWeight: "bold"
											}}
										>
											<CheckIcon style={{ fontSize: 14, color: "#2C2B2D" }} />
										</Box>
									}
									sx={{ p: 0 }} data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-checkbox"
								/>
							}
							label={
								<Typography className="accounted-for-label">
									<Translate value="global.sharedComponents.evacuationAccountability.accountedfor" />
								</Typography>
							}
							labelPlacement="start"
						/>
					</div>

					<div className="list-section-2" data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-div-5">
						<TargetingIcon
							id={person?.lastKnownLocation}
							feedId={person?.lastKnownLocationfeedId}
							geometry={person?.lastKnownLocationGeometry}
							iconContainerStyle={{
								width: 14,
								height: 14,
								padding: 0,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								marginTop: 4,
								marginInlineEnd: 5
							}}
							customStyles={{
								width: 14,
								height: 14
							}}
						/>

						<div className="last-known-section" data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-div-6">
							<div className="last-known-label">
								{getTranslation("global.sharedComponents.evacuationAccountability.lastKnownBadge")}
							</div>
							<div className="last-know-door-and-time">
								<span
									style={{
										display: "inline-block",
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
										minWidth: 50,
										maxWidth: 90
									}}
								>
									{person?.lastKnownLocationName}
								</span>
								<span
									style={{
										display: "inline-block",
										marginInlineStart: 2,
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
										minWidth: 100,
										maxWidth: 140
									}}
								>
									<span>{moment(person?.badgeReadTimestamp).local().format(timeFormatString)}</span>
								</span>
							</div>
						</div>
					</div>

					<div className="list-section-3" data-testid="orion-components-shared-components-evacuation-accountability-components-render-personnel-div-7">
						<div style={{ width: 80 }}>
							<div className="type-label ">
								{getTranslation("global.sharedComponents.evacuationAccountability.type")}
							</div>
							<div className="person-type">
								{getTranslation(`global.sharedComponents.evacuationAccountability.${person?.subtype?.toLowerCase()}`)}
							</div>
						</div>

						<div style={{ width: 165 }}>
							<div className="accountability-sector-label">
								{getTranslation("global.sharedComponents.evacuationAccountability.sector")}
							</div>
							<div className="person-sector">{person.accountabilitySectorName}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RenderPersonnel;
